<template>
    <div>
        <!--New Item Section-->
        <div v-if="componentVisible===true && isNewItem===true" class="row new-item mt-3">
            <div class="col-6">
                <el-autocomplete
                    class="dotted-outline"
                    style="width:100%"
                    v-model="newItemForm.item"
                    :clearable=true
                    :trigger-on-focus=true
                    :fetch-suggestions="querySearch"
                    key="id"
                    value-key="item_full"
                    placeholder="Select issue or type item"
                    @select="handleSelect"
                ></el-autocomplete>

                <!--<input class="form-control form-control-sm" v-model="newItemForm.item">-->
                <span class="invalid-feedback" :class="{'d-block': newItemForm.errors.has('item')}"
                      v-show="newItemForm.errors.has('item')">
                    {{ newItemForm.errors.get("item") }}
                </span>
            </div>

            <div class="col-2 item-number">
                <input class="form-control form-control-sm text-right" type="number" step="0.01"
                       placeholder="" v-model="newItemForm.total_excl">
                <span class="invalid-feedback"
                      :class="{'d-block': newItemForm.errors.has('total_excl')}"
                      v-show="newItemForm.errors.has('total_excl')">
                    {{ newItemForm.errors.get("total_excl") }}
                </span>
            </div>

            <div class="col-2 item-number">
                <input class="form-control form-control-sm text-right" type="number" step="0.01"
                       placeholder="" v-model="newItemForm.vat">
                <span class="invalid-feedback" :class="{'d-block': newItemForm.errors.has('vat')}"
                      v-show="newItemForm.errors.has('vat')">
                    {{ newItemForm.errors.get("vat") }}
                </span>
            </div>

            <div class="col-2 item-number">
                <input class="form-control form-control-sm text-right" type="number" step="0.01"
                       placeholder="" v-model="newItemForm.total_incl">
                <span class="invalid-feedback"
                      :class="{'d-block': newItemForm.errors.has('total_incl')}"
                      v-show="newItemForm.errors.has('total_incl')">
                    {{ newItemForm.errors.get("total_incl") }}
                </span>
            </div>

            <!--Notes Row-->
            <div class="col-12 mt-2">
                <textarea class="form-control form-control-sm" v-model="newItemForm.notes" placeholder="Notes"
                          style="width: 100%; height: 80px"></textarea>
            </div>
            <span class="invalid-feedback" :class="{'d-block': newItemForm.errors.has('notes')}"
                  v-show="newItemForm.errors.has('notes')">
                {{ newItemForm.errors.get("notes") }}
            </span>

            <div class="col-12 text-left">
                <a href="#" class="text-sm font-medium text-indigo-600 hover:text-indigo-500" @click.prevent="createNewLineItem()">
                    <i class="mdi mdi-plus-circle-outline text-info"></i> Create Line
                </a>
            </div>
        </div>

        <div v-else-if="isNewItem===false && mutableLineItem" class="row included-items"
             :class="{'editing-row': isEditing}">
            <div class="col-6" :class="{'pt-3 font-medium':isEditing}">
                <span @click.prevent="editLineItem" style="cursor: pointer">
                    {{ isEditing === true ? updateForm.item : mutableLineItem.item }}
                </span>
            </div>
            <div class="col-2 text-right">
                <span v-show="!isEditing">{{ parseFloat(mutableLineItem.total_excl).toFixed(2) }}</span>
            </div>
            <div class="col-2 text-right">
                <span v-show="!isEditing">{{ parseFloat(mutableLineItem.vat).toFixed(2) }}</span>
            </div>
            <div class="col-2 text-right">
                <span v-show="!isEditing">{{ parseFloat(mutableLineItem.total_incl).toFixed(2) }}</span>
            </div>
            <div v-if="isEditing" class="col-12">

                <div class="row new-item mt-3">
                    <div class="col-6">
                        <input class="form-control form-control-sm" v-model="updateForm.item">
                    </div>
                    <span class="invalid-feedback" :class="{'d-block': updateForm.errors.has('item')}"
                          v-show="updateForm.errors.has('item')">
                        {{ updateForm.errors.get("item") }}
                    </span>

                    <div class="col-2 item-number">
                        <input class="form-control form-control-sm text-right" type="number" step="0.01"
                               min="0" placeholder="" v-model="updateForm.total_excl">
                    </div>
                    <span class="invalid-feedback"
                          :class="{'d-block': updateForm.errors.has('total_excl')}"
                          v-show="updateForm.errors.has('total_excl')">{{ updateForm.errors.get("total_excl") }}
                    </span>


                    <div class="col-2 item-number">
                        <input class="form-control form-control-sm text-right" type="number" step="0.01"
                               min="0" placeholder="" v-model="updateForm.vat">
                    </div>
                    <span class="invalid-feedback" :class="{'d-block': updateForm.errors.has('vat')}"
                          v-show="updateForm.errors.has('vat')">{{ updateForm.errors.get("vat") }}
                    </span>


                    <div class="col-2 item-number">
                        <input class="form-control form-control-sm text-right" type="number" step="0.01"
                               min="0" placeholder="" v-model="updateForm.total_incl">
                    </div>
                    <span class="invalid-feedback"
                          :class="{'d-block': updateForm.errors.has('total_incl')}"
                          v-show="updateForm.errors.has('total_incl')">{{ updateForm.errors.get("total_incl") }}
                    </span>

                    <!--Notes Row-->
                    <div class="col-12 mt-2">
                        <textarea class="form-control form-control-sm" v-model="updateForm.notes" placeholder="Notes" style="width: 100%; height: 80px"></textarea>
                    </div>
                    <span class="invalid-feedback" :class="{'d-block': updateForm.errors.has('notes')}"
                          v-show="updateForm.errors.has('notes')">{{ updateForm.errors.get("notes") }}
                    </span>

                </div>

                <a class="btn btn-link text-success pl-0 pt-3" href="#" @click.prevent="updateItem"><i
                    class="mdi mdi-check-circle text-success"></i> Update Item</a>
                <a class="btn btn-link text-danger pt-3 pull-right" href="#" @click.prevent="deleteLineItem"><i
                    class="mdi mdi-delete-circle text-danger"></i> Delete Item</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "quote-invoice-line-item",

    props: [
        "quoteInvoice",
        "lineItem",
        "isNewItem",
        "companyVatPercentage",
        "vatCalculation",
        "autoCalculateVat"
    ],

    data () {
        return {
            mutableLineItem: this.lineItem,
            newItemForm: new AppForm({}),
            updateForm: new AppForm({}),
            isEditing: false,
            componentVisible: true,
            issueOptions: [],
        };
    },

    watch: {
        "newItemForm.total_excl": function (newVal) {
            if (this.autoCalculateVat && this.vatCalculation === "add vat") {
                this.newItemForm.vat = (newVal * this.companyVatPercentage).toFixed(2);
                this.newItemForm.total_incl = (parseFloat(newVal) + parseFloat(this.newItemForm.vat));
            }
        },

        "newItemForm.total_incl": function (newVal) {
            if (this.autoCalculateVat && this.vatCalculation === "subtract vat") {
                this.newItemForm.total_excl = (parseFloat(newVal) / (1 + this.companyVatPercentage)).toFixed(2);
                this.newItemForm.vat = (this.newItemForm.total_incl - this.newItemForm.total_excl).toFixed(2);
            }
        },

        "updateForm.total_excl": function (newVal) {
            if (this.autoCalculateVat && this.vatCalculation === "add vat") {
                this.updateForm.vat = (newVal * this.companyVatPercentage).toFixed(2);
                this.updateForm.total_incl = (parseFloat(newVal) + parseFloat(this.updateForm.vat));
            }
        },

        "updateForm.total_incl": function (newVal) {
            if (this.autoCalculateVat && this.vatCalculation === "subtract vat") {
                this.updateForm.total_excl = (parseFloat(newVal) / (1 + this.companyVatPercentage)).toFixed(2);
                this.updateForm.vat = (this.updateForm.total_incl - this.updateForm.total_excl).toFixed(2);
            }
        },
    },

    created () {
        let self = this;
        Bus.$on("toggle-editing-item", function (payload) {
            if (self.isNewItem === true) {
                payload.isEditing ? self.componentVisible = false : self.componentVisible = true;
            }
            if (self.mutableLineItem && self.mutableLineItem.id !== payload.id && payload.isEditing === true) {
                self.isEditing = false;
            }
        });
    },

    methods: {

        querySearch (queryString, cb) {
            axios.get("/tickets/" + this.quoteInvoice.ticket_id + "/issues/search", {
                params: {
                    filter: queryString
                }
            })
            .then((response) => {
                this.issueOptions = response.data;
                cb(response.data);
            });
        },
        createFilter (queryString) {
            return (issueOption) => {
                return (issueOption.item_full.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
            };
        },

        handleSelect (item) {

        },

        resetNewItemForm () {
            this.newItemForm = new AppForm({});
        },

        editLineItem () {
            this.isEditing = !this.isEditing;
            if (this.isEditing === true) {
                Bus.$emit("toggle-editing-item", {id: this.mutableLineItem.id, isEditing: true});
                this.updateForm = new AppForm({
                    item: this.mutableLineItem.item,
                    notes: this.mutableLineItem.notes,
                    total_excl: this.mutableLineItem.total_excl,
                    total_incl: this.mutableLineItem.total_incl,
                    vat: this.mutableLineItem.vat,
                });
            } else {
                Bus.$emit("toggle-editing-item", {id: this.mutableLineItem.id, isEditing: false});
            }
        },

        updateItem () {
            App.patch("/quotes-invoices/line-items/" + this.mutableLineItem.id + "/update", this.updateForm)
            .then((response) => {
                this.isEditing = false;
                this.$emit("line-item-updated", response);
                this.mutableLineItem = response;
                Bus.$emit("toggle-editing-item", {id: this.mutableLineItem.id, isEditing: false});
                toastr.success("Item Updated");
            }).catch((errors) => {
                toastr.error("Error updating item");
            });
        },

        createNewLineItem () {
            App.post("/quotes-invoices/" + this.quoteInvoice.id + "/line-items/create", this.newItemForm)
            .then((response) => {
                toastr.success("New Item Added");
                this.newItemForm = new AppForm({});
                this.$emit("new-line-added", response);
            }).catch((errors) => {
                toastr.error("Error creating new line!");
            });
        },

        deleteLineItem () {
            App.delete("/quotes-invoices/line-items/" + this.mutableLineItem.id + "/delete", new AppForm({}))
            .then((response) => {
                this.$emit("line-item-deleted", this.mutableLineItem.id);
                Bus.$emit("toggle-editing-item", {id: this.mutableLineItem.id, isEditing: false});
                toastr.success("Line item deleted");
            }).catch((errors) => {
                toastr.error("Error deleting line item");
            });
        },
    }

};
</script>

<style scoped>
.row.included-items {
    font-size: .9em;
    padding: 4px 2px;
}

.even-row .row.included-items {
    background: #f1f1f1a1;
}

.dotted-outline .el-input__inner {
    border: 1px dotted #DDD !important;
    font-size: 13px !important;
}

.editing-row {
    border-top: 2px solid #b11623;
    border-bottom: 2px solid #b11623;
    padding: 4px 2px 12px 2px !important;
}

.new-item .form-control {
    border: 1px dotted #DDD;
    padding: 5px;
    min-height: 18px;
    font-size: 13px;
}

.new-item .item-number {
    text-align: right;
    padding-left: 0 !important;
    /*padding-right: 10px;*/
}

/* For Firefox */
.new-item input[type='number'] {
    -moz-appearance: textfield;
}

/* Webkit browsers like Safari and Chrome */
.new-item input[type=number]::-webkit-inner-spin-button,
.new-item input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

</style>
